export const CorporateGovernance = {
  list: (status?: string) => `corporate-governance${status ? `?status=${status}` : ''}`,
  detail: (id: number) => `corporate-governance/${id}`,
  create: `corporate-governance`,
  update: (id: number) => `corporate-governance/${id}`,
  reorder: `corporate-governance/reorder`,
  topShareholders: (limit: number = 20) => `top-shareholders?limit=${limit}`,
  settings: `corporate-governance-settings`
}
